export const IP_BLOCKLIST_TERMS: readonly string[] = [
  'pokemon',
  'pokémon',
  'pikachu',
  'paw patrol',
  'chase',
  'marshall',
  'skye',
  'rubble',
  'disney',
  'mickey',
  'minnie',
  'frozen',
  'elsa',
  'anna',
  'marvel',
  'spiderman',
  'spider-man',
  'batman',
  'superman',
  'peppa',
  'bluey',
  'super mario',
  'mario',
  'luigi',
  'hello kitty',
  'minions',
  'winnie pooh',
  'winnie-the-pooh',
  'sesame street',
  'cookie monster',
  'elmo',
];

export interface BlocklistMatch {
  term: string;
  field: string;
}

export function findBlocklistMatches(
  inputs: Record<string, string | null | undefined>,
): BlocklistMatch[] {
  const matches: BlocklistMatch[] = [];
  for (const [field, value] of Object.entries(inputs)) {
    if (!value) continue;
    const lower = value.toLowerCase();
    for (const term of IP_BLOCKLIST_TERMS) {
      if (lower.includes(term)) {
        matches.push({ term, field });
      }
    }
  }
  return matches;
}

export function classifyVisionConfidence(
  confidence: number,
): 'allow' | 'manual_review' | 'block' {
  if (confidence >= 0.8) return 'block';
  if (confidence >= 0.45) return 'manual_review';
  return 'allow';
}
